import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box } from '@mui/material';
import { TailSpin } from 'react-loader-spinner';
import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
var options = {
    cMapUrl: '/cmaps/',
    standardFontDataUrl: '/standard_fonts/',
};
export var BackrsPDFPreview = function (_a) {
    var documentUrl = _a.documentUrl, onError = _a.onError, _b = _a.width, width = _b === void 0 ? 800 : _b;
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    return (_jsx(Box, { onClick: function () { return window.open(documentUrl); }, sx: containerStyle, children: _jsx(Box, { sx: pdfContainerStyle, children: _jsxs(Document, { file: documentUrl, onLoadError: onError, loading: "", options: options, children: [isLoading && (_jsx(Box, { sx: loadingContainerStyle, children: _jsx(TailSpin, { color: "#000", height: 50, width: 50 }) })), _jsx(Page, { onRenderSuccess: function () { return setIsLoading(false); }, loading: "", pageNumber: 1, width: width })] }) }) }));
};
var containerStyle = {
    mt: 3,
    cursor: 'pointer',
};
var pdfContainerStyle = {
    mt: 3,
    cursor: 'pointer',
    height: 400,
    overflow: 'hidden',
    flexDirection: 'column',
    alignItems: 'center',
    display: 'flex',
};
var loadingContainerStyle = {
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
